import update from 'immutability-helper';
// eslint-disable-next-line import/no-cycle
import {
  SHOWCASES_PROGRESS,
  SHOWCASES_SUCCESS,
  SHOWCASES_FAILED,
  SHOWCASES_GET_LIST_PROGRESS,
  SHOWCASES_GET_LIST_SUCCESS,
  SHOWCASES_GET_LIST_FAILED,
  SHOWCASES_FORM_SUBMIT_PROGRESS,
  SHOWCASES_FORM_SUBMIT_SUCCESS,
  SHOWCASES_FORM_SUBMIT_FAILED,
  SHOWCASES_GET_SHOWCASE_PROGRESS,
  SHOWCASES_GET_SHOWCASE_SUCCESS,
  SHOWCASES_GET_SHOWCASE_FAILED,
  SHOWCASES_GET_ASYNC_DATA_PROGRESS,
  SHOWCASES_GET_ASYNC_DATA_SUCCESS,
  SHOWCASES_GET_ASYNC_DATA_FAILED,
  SHOWCASES_CLEAR_STATE,
  SHOWCASES_CLEAR_FLASH_MESSAGE,
} from '../actions/showcasesAction';

const initialState = {
  loadListStatus: '', // progress/success/failed
  loadActiveStatus: '', // progress/success/failed
  submitStatus: '', // progress/success/failed
  asyncStatus: '', // progress/success/failed
  list: [],
  pagination: {},
  active: {},
  asyncData: {},
  flash: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SHOWCASES_GET_LIST_PROGRESS: {
      return update(state, {
        list: { $set: [] },
        pagination: { $set: {} },
        loadListStatus: { $set: SHOWCASES_PROGRESS },
      });
    }
    case SHOWCASES_GET_LIST_SUCCESS: {
      return update(state, {
        list: { $set: action.payload.list },
        pagination: { $set: action.payload.pagination },
        loadListStatus: { $set: SHOWCASES_SUCCESS },
      });
    }
    case SHOWCASES_GET_LIST_FAILED: {
      return update(state, {
        list: { $set: [] },
        pagination: { $set: {} },
        loadListStatus: { $set: SHOWCASES_FAILED },
      });
    }
    case SHOWCASES_FORM_SUBMIT_PROGRESS: {
      return update(state, { submitStatus: { $set: SHOWCASES_PROGRESS } });
    }
    case SHOWCASES_FORM_SUBMIT_SUCCESS: {
      return update(state, {
        flash: { $set: action.payload },
        submitStatus: { $set: SHOWCASES_SUCCESS },
      });
    }
    case SHOWCASES_FORM_SUBMIT_FAILED: {
      return update(state, { submitStatus: { $set: SHOWCASES_FAILED } });
    }
    case SHOWCASES_GET_SHOWCASE_PROGRESS: {
      return update(state, {
        active: { $set: {} },
        loadActiveStatus: { $set: SHOWCASES_PROGRESS },
      });
    }
    case SHOWCASES_GET_SHOWCASE_SUCCESS: {
      return update(state, {
        active: { $set: action.payload.showcase },
        loadActiveStatus: { $set: SHOWCASES_SUCCESS },
      });
    }
    case SHOWCASES_GET_SHOWCASE_FAILED: {
      return update(state, {
        active: { $set: {} },
        loadActiveStatus: { $set: SHOWCASES_FAILED },
      });
    }
    case SHOWCASES_GET_ASYNC_DATA_PROGRESS: {
      return update(state, {
        asyncData: { $set: {} },
        asyncStatus: { $set: SHOWCASES_PROGRESS },
      });
    }
    case SHOWCASES_GET_ASYNC_DATA_SUCCESS: {
      return update(state, {
        asyncData: { $set: action.payload },
        asyncStatus: { $set: SHOWCASES_SUCCESS },
      });
    }
    case SHOWCASES_GET_ASYNC_DATA_FAILED: {
      return update(state, {
        asyncData: { $set: {} },
        asyncStatus: { $set: SHOWCASES_FAILED },
      });
    }
    case SHOWCASES_CLEAR_STATE: {
      return update(state, {
        loadListStatus: { $set: '' },
        loadActiveStatus: { $set: '' },
        submitStatus: { $set: '' },
        asyncStatus: { $set: '' },
        list: { $set: [] },
        pagination: { $set: {} },
        active: { $set: {} },
        asyncData: { $set: {} },
      });
    }
    case SHOWCASES_CLEAR_FLASH_MESSAGE: {
      return update(state, {
        flash: { $set: '' },
      });
    }
    default:
      return state;
  }
}
